import { BILLING_FREQUENCY_ORDER } from '@proposify/pricing-engine';
import type { BillingFrequency, FrequencyTotals } from '@proposify/pricing-engine';

const ONE_TIME_FREQUENCY: BillingFrequency = 'one-time';

const BILLING_FREQUENCY_FALLBACK_LABELS: Record<Exclude<BillingFrequency, 'one-time'>, string> = {
  daily: 'Daily',
  weekly: 'Weekly',
  'bi-weekly': 'Bi-weekly',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  annual: 'Annual',
};

export type FrequencyFooterRow = {
  frequency: BillingFrequency;
  labelKey: string;
  fallbackLabel: string;
  total: string;
};

export type FrequencyFooterData = {
  hasNonOneTime: boolean;
  oneTimeTotal: string;
  frequencyRows: FrequencyFooterRow[];
};

const toTranslationKeySegment = (frequency: BillingFrequency): string => frequency.replace(/-/g, '_');

export const getFrequencyFooterData = (
  presentFrequencies: BillingFrequency[],
  frequencyTotals: FrequencyTotals | null
): FrequencyFooterData => {
  const nonOneTimeFrequencies = BILLING_FREQUENCY_ORDER.filter(
    (frequency): frequency is Exclude<BillingFrequency, 'one-time'> =>
      frequency !== ONE_TIME_FREQUENCY && presentFrequencies.includes(frequency)
  );

  return {
    hasNonOneTime: nonOneTimeFrequencies.length > 0,
    oneTimeTotal: frequencyTotals?.[ONE_TIME_FREQUENCY] ?? '0',
    frequencyRows: nonOneTimeFrequencies.map((frequency) => ({
      frequency,
      labelKey: `pricing.footer.frequency_subtotal.${toTranslationKeySegment(frequency)}`,
      fallbackLabel: `${BILLING_FREQUENCY_FALLBACK_LABELS[frequency]} subtotal`,
      total: frequencyTotals?.[frequency] ?? '0',
    })),
  };
};
